import { useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import LicenseExpired from "@/pages/LicenseExpired";

export default function Shell() {
  const { user } = useAuth();
  const role = user?.role;

  if (role === "empresa_admin" || role === "empresa_user") {
    if (!user.license || user.license.bloqueada) return <LicenseExpired />;
  }
  return <Layout />;
}
